import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LicenseInfo } from '@mui/x-license';
const root = ReactDOM.createRoot(document.getElementById('root'));
const licenseKey= process.env.REACT_APP_MUI_PREMIUM_LICENSE_KEY;
LicenseInfo.setLicenseKey(licenseKey);

root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals( 
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
